import React from 'react';
import { Phone, MessageCircle, Mail, MapPin, Clock, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { AGENT } from '../mock/mock';

const Contact = () => {
  return (
    <section id="contact" className="py-20 lg:py-24 relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="relative rounded-[36px] overflow-hidden bg-gradient-to-br from-[#3D1568] via-[#5F259F] to-[#7C3AED] p-8 lg:p-14 premium-shadow">
          {/* decoration */}
          <div className="absolute -top-24 -right-24 w-80 h-80 rounded-full bg-white/10 blur-2xl" />
          <div className="absolute -bottom-32 -left-24 w-96 h-96 rounded-full bg-violet-300/20 blur-3xl" />
          <div className="absolute top-6 right-8 w-16 h-16 rounded-2xl border border-white/20 rotate-12" />
          <div className="absolute bottom-10 right-32 w-10 h-10 rounded-xl bg-white/10 -rotate-6" />

          <div className="relative grid lg:grid-cols-2 gap-10 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/15 border border-white/25 backdrop-blur-md">
                <Sparkles className="w-3.5 h-3.5 text-amber-300" />
                <span className="text-[11px] font-bold text-white uppercase tracking-wider">Let's Talk Business</span>
              </div>
              <h2 className="mt-4 text-4xl lg:text-5xl font-extrabold text-white leading-[1.1]">
                Ready to power your<br />business with <span className="text-amber-300">smart payments?</span>
              </h2>
              <p className="mt-4 text-purple-100 text-[15px] max-w-md">
                Talk to Ashish personally. Get the best offer, free installation and 24/7 local support — all in a single call.
              </p>
              <div className="mt-6 flex flex-wrap gap-3">
                <Button className="bg-white text-[#5F259F] hover:bg-purple-50 rounded-2xl h-13 px-6 h-12 font-extrabold shadow-lg">
                  <Phone className="w-4 h-4 mr-2" /> Call Now
                </Button>
                <Button className="bg-emerald-500 hover:bg-emerald-600 text-white rounded-2xl h-12 px-6 font-extrabold shadow-lg">
                  <MessageCircle className="w-4 h-4 mr-2" /> WhatsApp Us
                </Button>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3">
              {[
                { icon: Phone, label: 'Call', value: AGENT.phone },
                { icon: MessageCircle, label: 'WhatsApp', value: AGENT.whatsapp },
                { icon: Mail, label: 'Email', value: AGENT.email },
                { icon: MapPin, label: 'Coverage', value: AGENT.coverage },
                { icon: Clock, label: 'Hours', value: AGENT.hours },
                { icon: Sparkles, label: 'Available', value: '7 Days a Week' },
              ].map((c, i) => {
                const I = c.icon;
                return (
                  <div key={i} className="rounded-2xl p-4 bg-white/15 border border-white/25 backdrop-blur-xl hover-lift">
                    <div className="w-10 h-10 rounded-xl bg-white/25 flex items-center justify-center">
                      <I className="w-5 h-5 text-white" />
                    </div>
                    <div className="mt-2 text-[11px] font-bold text-white/90 uppercase tracking-wider">{c.label}</div>
                    <div className="text-white font-bold text-[13px] truncate mt-0.5">{c.value}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
